/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */
import { Signer, utils, Contract, ContractFactory, Overrides } from "ethers";
import { Provider, TransactionRequest } from "@ethersproject/providers";
import type {
  ERC721MinterBurnerPauser,
  ERC721MinterBurnerPauserInterface,
} from "../ERC721MinterBurnerPauser";

const _abi = [
  {
    inputs: [
      {
        internalType: "string",
        name: "name",
        type: "string",
      },
      {
        internalType: "string",
        name: "symbol",
        type: "string",
      },
      {
        internalType: "string",
        name: "tokenBaseURI",
        type: "string",
      },
    ],
    stateMutability: "nonpayable",
    type: "constructor",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "owner",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "approved",
        type: "address",
      },
      {
        indexed: true,
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
    ],
    name: "Approval",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "owner",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "operator",
        type: "address",
      },
      {
        indexed: false,
        internalType: "bool",
        name: "approved",
        type: "bool",
      },
    ],
    name: "ApprovalForAll",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "account",
        type: "address",
      },
    ],
    name: "Paused",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "bytes32",
        name: "role",
        type: "bytes32",
      },
      {
        indexed: true,
        internalType: "address",
        name: "account",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "sender",
        type: "address",
      },
    ],
    name: "RoleGranted",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "bytes32",
        name: "role",
        type: "bytes32",
      },
      {
        indexed: true,
        internalType: "address",
        name: "account",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "sender",
        type: "address",
      },
    ],
    name: "RoleRevoked",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "from",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "to",
        type: "address",
      },
      {
        indexed: true,
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
    ],
    name: "Transfer",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "account",
        type: "address",
      },
    ],
    name: "Unpaused",
    type: "event",
  },
  {
    inputs: [],
    name: "DEFAULT_ADMIN_ROLE",
    outputs: [
      {
        internalType: "bytes32",
        name: "",
        type: "bytes32",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "MINTER_ROLE",
    outputs: [
      {
        internalType: "bytes32",
        name: "",
        type: "bytes32",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "PAUSER_ROLE",
    outputs: [
      {
        internalType: "bytes32",
        name: "",
        type: "bytes32",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "to",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
    ],
    name: "approve",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "owner",
        type: "address",
      },
    ],
    name: "balanceOf",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "baseURI",
    outputs: [
      {
        internalType: "string",
        name: "",
        type: "string",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
    ],
    name: "burn",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
    ],
    name: "getApproved",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "role",
        type: "bytes32",
      },
    ],
    name: "getRoleAdmin",
    outputs: [
      {
        internalType: "bytes32",
        name: "",
        type: "bytes32",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "role",
        type: "bytes32",
      },
      {
        internalType: "uint256",
        name: "index",
        type: "uint256",
      },
    ],
    name: "getRoleMember",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "role",
        type: "bytes32",
      },
    ],
    name: "getRoleMemberCount",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "role",
        type: "bytes32",
      },
      {
        internalType: "address",
        name: "account",
        type: "address",
      },
    ],
    name: "getRoleMemberIndex",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "role",
        type: "bytes32",
      },
      {
        internalType: "address",
        name: "account",
        type: "address",
      },
    ],
    name: "grantRole",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "role",
        type: "bytes32",
      },
      {
        internalType: "address",
        name: "account",
        type: "address",
      },
    ],
    name: "hasRole",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "owner",
        type: "address",
      },
      {
        internalType: "address",
        name: "operator",
        type: "address",
      },
    ],
    name: "isApprovedForAll",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "name",
    outputs: [
      {
        internalType: "string",
        name: "",
        type: "string",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
    ],
    name: "ownerOf",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "paused",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "role",
        type: "bytes32",
      },
      {
        internalType: "address",
        name: "account",
        type: "address",
      },
    ],
    name: "renounceRole",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "role",
        type: "bytes32",
      },
      {
        internalType: "address",
        name: "account",
        type: "address",
      },
    ],
    name: "revokeRole",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "from",
        type: "address",
      },
      {
        internalType: "address",
        name: "to",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
    ],
    name: "safeTransferFrom",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "from",
        type: "address",
      },
      {
        internalType: "address",
        name: "to",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
      {
        internalType: "bytes",
        name: "_data",
        type: "bytes",
      },
    ],
    name: "safeTransferFrom",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "operator",
        type: "address",
      },
      {
        internalType: "bool",
        name: "approved",
        type: "bool",
      },
    ],
    name: "setApprovalForAll",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes4",
        name: "interfaceId",
        type: "bytes4",
      },
    ],
    name: "supportsInterface",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "symbol",
    outputs: [
      {
        internalType: "string",
        name: "",
        type: "string",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "from",
        type: "address",
      },
      {
        internalType: "address",
        name: "to",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
    ],
    name: "transferFrom",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "to",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
      {
        internalType: "string",
        name: "_data",
        type: "string",
      },
    ],
    name: "mint",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "pause",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "unpause",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
    ],
    name: "tokenURI",
    outputs: [
      {
        internalType: "string",
        name: "",
        type: "string",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
];

const _bytecode =
  "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";

type ERC721MinterBurnerPauserConstructorParams =
  | [signer?: Signer]
  | ConstructorParameters<typeof ContractFactory>;

const isSuperArgs = (
  xs: ERC721MinterBurnerPauserConstructorParams
): xs is ConstructorParameters<typeof ContractFactory> => xs.length > 1;

export class ERC721MinterBurnerPauser__factory extends ContractFactory {
  constructor(...args: ERC721MinterBurnerPauserConstructorParams) {
    if (isSuperArgs(args)) {
      super(...args);
    } else {
      super(_abi, _bytecode, args[0]);
    }
    this.contractName = "ERC721MinterBurnerPauser";
  }

  deploy(
    name: string,
    symbol: string,
    tokenBaseURI: string,
    overrides?: Overrides & { from?: string | Promise<string> }
  ): Promise<ERC721MinterBurnerPauser> {
    return super.deploy(
      name,
      symbol,
      tokenBaseURI,
      overrides || {}
    ) as Promise<ERC721MinterBurnerPauser>;
  }
  getDeployTransaction(
    name: string,
    symbol: string,
    tokenBaseURI: string,
    overrides?: Overrides & { from?: string | Promise<string> }
  ): TransactionRequest {
    return super.getDeployTransaction(
      name,
      symbol,
      tokenBaseURI,
      overrides || {}
    );
  }
  attach(address: string): ERC721MinterBurnerPauser {
    return super.attach(address) as ERC721MinterBurnerPauser;
  }
  connect(signer: Signer): ERC721MinterBurnerPauser__factory {
    return super.connect(signer) as ERC721MinterBurnerPauser__factory;
  }
  static readonly contractName: "ERC721MinterBurnerPauser";
  public readonly contractName: "ERC721MinterBurnerPauser";
  static readonly bytecode = _bytecode;
  static readonly abi = _abi;
  static createInterface(): ERC721MinterBurnerPauserInterface {
    return new utils.Interface(_abi) as ERC721MinterBurnerPauserInterface;
  }
  static connect(
    address: string,
    signerOrProvider: Signer | Provider
  ): ERC721MinterBurnerPauser {
    return new Contract(
      address,
      _abi,
      signerOrProvider
    ) as ERC721MinterBurnerPauser;
  }
}
